import {
  performGetToBackend,
  performPutToBackend,
} from '@/flagler-api/backend-api';

import { PagedNotifications } from '@/types/Api/Notification';

import { useUserStore } from '@/stores/UserStore';

export function getNotifications(
  unreadOnly = false,
  page = 1,
  pageSize = 10,
  userIds?: string[]
): Promise<{ data: PagedNotifications }> {
  return performGetToBackend('/user/notifications', {
    unreadOnly: unreadOnly ? 1 : undefined,
    page,
    pageSize,
    userIds,
  });
}

export function getOneNotification(notificationId: string) {
  return performGetToBackend(`/user/notification/${notificationId}`, {
    userIds: useUserStore().allUserIds,
  });
}

export function markNotificationAsRead(notificationId: string, read = true) {
  return performPutToBackend('/user/notifications/read', {
    notificationIds: [notificationId],
    read,
  });
}

export function markNotificationsAsRead(
  notificationIds: string[],
  read = true
) {
  return performPutToBackend('/user/notifications/read', {
    notificationIds: notificationIds,
    read,
    userIds: useUserStore().allUserIds,
  });
}
